import { useState } from 'react'
import { CircularProgress, Typography, Button, Switch } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import styles from './login.less'
import FormItem from '../../../components/FormItem/item.js'

import {
    LoginAction
} from '../actions'
import logo from '../../../assets/logo.png'
import { useSnackbar } from 'notistack';
import ExirioStyles from '../../../utils/exirioStyles'
import LoginHandler from './LoginHandler'



const LoginComp = () => {

    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [rememberMe, setRememberMe] = useState(true)
    const { loginLoader, loginPayload, isMobile } = useSelector(state => ({
        isMobile: state.theme.isMobile,
        loginPayload: state.login.loginPayload,
        loginLoader: state.login.loginLoader,
    }))

    const [validate, setValidate] = useState(false);

    const useStyles = makeStyles(theme => ({

        navLogo: {
            fontSize: '28px',
            fontFamily: 'Source Sans Pro',
            color: 'white'

        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center'
        },

        guestLoginWrp: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '13px',
            paddingBottom: '5px'
        },
        //////////////////new styles
        title: {
            color: ExirioStyles.secondaryWhiteText,
            fontSize: '23px',
            color: 'lightgray',
            width: '100%',
            padding: '11px 8px',
            borderBottom: '1px solid',
            borderBlockColor: ExirioStyles.background
            // borderColor:ExirioStyles.background

        },
        smtitle: {
            // color: ExirioStyles.secondaryWhiteText,
            fontSize: '16px',
            // color: 'lightgray'
        },
        socialReg: {
            display: 'flex',
            justifyContent: 'space-around',
            width: '40%',
            marginTop: '15px',
            marginBottom: '10px'
        },
        mobSocialReg: {
            display: 'flex',
            justifyContent: 'space-around',
            width: '80%',
            marginTop: '15px',
            marginBottom: '10px'
        },
        regForm: {
            display: 'flex',
            justifyContent: 'center',
            width: '60%',
            paddingTop: '20px',
            // paddingBottom: '10px'
        },
        mobRegForm: {
            display: 'flex',
            justifyContent: 'center',
            width: '85%',
            paddingTop: '20px',
            // paddingBottom: '10px'
        },
        btnWrap: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '20px',
            paddingBottom: '20px'
        },
        btn: {
            borderRadius: 40,
            padding: '8px 28px 8px 28px',
            backgroundColor:'#006DEA'

        },
        loader: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.3)'
        },
        headWrapper: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        },
        circleIcon: {
            width: '40px',
            height: "40px",
            borderRadius: "50%",
            textAlign: "center",
            // lineHeight: "20px",
            cursor: "pointer",
        },
        deltrack: {
            backgroundColor: rememberMe ? ExirioStyles.background : '',
        },
        delThumb: {
            color: rememberMe ? 'lightgray' : ExirioStyles.background,
        },
        switchTextWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        mobSwitchTextWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        switchesCont: {
            marginTop: '30px'
        },
        rowWrap: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '12px 0px 12px 0px'
        },
        colWrap: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            margin: '8px 0px 8px 0px'
        }
    }))

    const classes = useStyles()

    const [values, setValues] = useState({
        email: '',
        password: '',
    })

    const handleAddToHomescreenClick = () => {
        alert(`
    1. Open Share menu
    2. Tap on "Add to Home Screen" button`)
    }

    // useEffect(() => {
    //     if (loginPayload && loginPayload.success && loginPayload.data) {
    //         let token = loginPayload.data.autho_token
    //         const twoFactorLoginResult = loginPayload.data;
    //         if (!token && twoFactorLoginResult?.two_factor_auth_enabled) {
    //             dispatch({ type: 'SET_LOGIN_RESPONSE_FOR_TWOFACTOR', payload: loginPayload?.data });
    //             dispatch(push('/two_factor_authentication'));
    //             return;
    //           }

    //         let decodedUser = jwt_decode(token)
    //         if (decodedUser && decodedUser['user-data']) {
    //             dispatch({ type: 'SET_CURRENT_USER', user: decodedUser['user-data'] })
    //         }
    //         dispatch({ type: 'SET_AUTH_TOKEN', token: loginPayload.data.autho_token })
    //         dispatch(push('/publicInstrument'))
    //     }
    //     else if (loginPayload && loginPayload.error) {
    //         enqueueSnackbar(`Login failed. ${loginPayload.message}`, {
    //             variant: 'error',
    //         });
    //     }
    //     dispatch({ type: 'NATIVE_LOGIN', payload: null })

    // }, [dispatch, enqueueSnackbar, loginPayload])


    const checkReqiredFields = () => {
        if (!values.email) return ({ error: true, success: false, message: 'Please enter email address.' })
        if (!values.password) return ({ error: true, success: false, message: 'Please enter password.' })
        return ({ error: false, success: true })
    }

    const onChange = (prop) => (e) => {
        e.preventDefault()
        e.persist()
        setValues(() => ({ ...values, [prop]: prop === 'email' ? e.target.value?.toLowerCase() : e.target.value }))
    }
    const onSubmit = async (e) => {
         e.preventDefault();
        let { success, message } = await checkReqiredFields()
        if (success) {
            let payload = {}
            payload = {
                ...payload,
                ...values,
                remember_me: rememberMe
            }
            localStorage.setItem('rememberMeAdmin', rememberMe)
            dispatch(LoginAction(payload,enqueueSnackbar))
        } else {
            setValidate(true);
            enqueueSnackbar(` ${message}`, {
                variant: 'error',
            });
        }
    }

    const handleKeypress = e => {
        if (e.keyCode === 13) {
        onSubmit();
        }
    };

    return (
        <LoginHandler>{
            loginLoader &&
            <div className={classes.loader}>
                <CircularProgress />
            </div>
          }

            <div className={styles.content}>
                <div className={styles.main}>
                    <div className={classes.title}>
                        <Typography> Log in to Exirio</Typography>
                    </div>
                    <div className={styles.logo}>
                        <div className={classes.flexCenter}>
                            <img src={logo} alt="logo" className={styles.wealthLogo} />
                            <Typography className={classes.navLogo} variant='h4' color="primary" >
                                EXIRIO
                            </Typography>
                        </div>
                        {/* <Typography className={styles.logos} variant='h6' >
                        Welcome back! Log in to continue
                    </Typography> */}
                    </div>
                    <div className={classes.headWrapper}>
                        <Typography className={styles.logos} variant='h6' >
                            Welcome back!
                        </Typography>
                        <Typography className={classes.smtitle} >
                            {'or enter your own details'}
                        </Typography>
                    </div>
                    <div className={isMobile ? classes.mobRegForm : classes.regForm}>
                        <form autoComplete='on'>

                            <FormItem
                                id={'email'}
                                name={'email'}
                                autoComplete={'on'}
                                autocompletetype={'username email'}
                                value={values.email}
                                label={'Email address'}
                                handleChange={onChange('email')}
                                onKeyPress={handleKeypress}
                            //    error={validate && !values.email}
                                required={true}
                                size={'small'}
                                margin={'dense'}
                            />

                            <FormItem
                                inputType={'PASSWORD'}
                                id={'password'}
                                autocompletetype={'new-password'}
                                autoComplete={'on'}
                                label={'Password *'} //TODO: Hardcoding the * in the label because the required attribute is not doing it for this field
                                value={values.password}
                                email={values.email}
                                showPassword={values.showPassword}
                                handleChange={onChange('password')}
                                onKeyPress={handleKeypress}
                                // error={validate && !values.password}
                                required={true}
                                size={'small'}
                                margin={'dense'}
                            />
                            <div className={isMobile ? classes.colWrap : classes.rowWrap}>
                                <div className={classes.switchTextWrapper}>
                                    <Switch
                                        checked={rememberMe}
                                        onClick={() => setRememberMe((prev) => !prev)}
                                        // onChange={(e) => setRememberMe(e?.target?.checked)}
                                        size="small"
                                        classes={{
                                            track: classes.deltrack,
                                            thumb: classes.delThumb,
                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                    <span>Remember me</span>
                                    {/* <Typography className={classes.txt} variant={'subtitle2'}>Remember me</Typography> */}

                                </div>
                            </div>

                            <div className={classes.btnWrap} >
                                <Button size="medium" className={classes.btn} disabled={loginLoader} variant="contained" color="primary" type="submit" onClick={onSubmit}>
                                    Log in
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </LoginHandler>
    )
}
export default LoginComp